<div fxLayoutAlign="center center" class="background" fxLayout="column" fxFlexFill>
  <img fxFlex="50" src="assets/404pageNotFound.png">
  <div fxFlex="8" fxLayoutAlign="center center">
    <button mat-raised-button [routerLink]="'/private'" color="primary" type="button">Regresar al inicio</button>
  </div>
</div>
